import {
  breakpointSizes,
  ButtonDesigns,
  ButtonTypes,
  getBreakpointDown,
  styleConstants,
} from '@paywithextend/components'
import React from 'react'
import { useSelector } from 'react-redux'
import Button from 'src/components/Button/Button'
import SvgChevronDown from 'src/components/Svgs/SvgChevronDown'
import SvgChevronUp from 'src/components/Svgs/SvgChevronUp'
import { useTranslate } from 'src/localization/Trns'
import { selectBrandColorCta } from 'src/redux/selectors/session.selectors'
import styled, { css } from 'styled-components'

interface FilterButtonProps {
  filterCount?: number
  filtersOpen: boolean
  onClick: () => void
  hideChevron?: boolean
}

const ButtonDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const FilterButton: React.FC<FilterButtonProps> = (
  props,
): React.ReactElement => {
  const translate = useTranslate()

  const brandColorCta = useSelector(selectBrandColorCta)

  const chevron = props.filtersOpen ? (
    <SvgChevronUp fill={styleConstants.colors.white} />
  ) : (
    <SvgChevronDown fill={brandColorCta} />
  )

  return (
    <Button
      css={css`
        justify-content: center;
        box-shadow:
          0 2px 5px 0 rgba(0, 0, 0, 0.15),
          inset 0px 0px 0px 1px ${styleConstants.colors.gray_medium};
        ${getBreakpointDown(breakpointSizes.SM)(css`
          span[class^='Button___StyledSpan2-sc-78et53-3'] {
            width: 100%;
          }
          span[class^='text'] {
            width: 100%;
          }
        `)}
        ${getBreakpointDown(breakpointSizes.SM)(css`
          width: 100%;
        `)}
      `}
      testId={'filtersBtn'}
      onClick={props.onClick}
      design={
        props.filtersOpen
          ? ButtonDesigns.designCta
          : ButtonDesigns.designCtaInverse
      }
      type={ButtonTypes.button}
      text={
        <>
          {props.filterCount && props.filterCount > 0 ? (
            <ButtonDiv>
              {translate('Filters (${count})', {
                count: `${props.filterCount}`,
              })}
              {!props.hideChevron && chevron}
            </ButtonDiv>
          ) : (
            <ButtonDiv>
              {translate('Filters')}
              {!props.hideChevron && chevron}
            </ButtonDiv>
          )}
        </>
      }
    />
  )
}

export default FilterButton
